// Brand wordmark — "DreamBook" in the v1 design-language register.
//
// Two-tone Cormorant italic with flanking foil fleurons. An optional
// tagline "Dreambook into being" sits beneath the wordmark in small
// italic Cormorant, framed by two foil hairline ticks — reads like the
// subtitle on a printed title page. Tagline is opt-in via the `tagline`
// prop so it can stay off in the tight nav header and on in the hero
// and footer where there's room for it to breathe.
export function Brand({
  className = "",
  size = "md",
  tagline = false,
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
  tagline?: boolean;
}) {
  const wordmarkSize =
    size === "lg" ? "text-[34px]"
  : size === "sm" ? "text-[20px]"
  :                 "text-[28px]";

  const taglineSize =
    size === "lg" ? "text-[15px]"
  : size === "sm" ? "text-[10px]"
  :                 "text-[12px]";

  return (
    <span className={`inline-flex flex-col items-center gap-1.5 ${className}`} aria-label="DreamBook — dreambook into being">
      <span className={`font-serif italic font-medium inline-flex items-baseline gap-2 leading-none ${wordmarkSize}`}>
        <span className="text-foil-bright not-italic text-[0.55em] -translate-y-[0.15em] inline-block opacity-90" aria-hidden>❦</span>
        <span className="text-terracotta tracking-[-0.015em]">Dream</span><span className="text-ink-body tracking-[-0.015em]">Book</span>
        <span className="text-foil-bright not-italic text-[0.55em] -translate-y-[0.15em] inline-block opacity-70" aria-hidden>❦</span>
      </span>
      {tagline ? (
        <span
          className={`font-serif italic tracking-[0.04em] text-ink-dim ${taglineSize} inline-flex items-center gap-2 leading-none`}
          aria-hidden
        >
          <span className="inline-block w-5 h-px bg-foil opacity-60" />
          Dreambook into being
          <span className="inline-block w-5 h-px bg-foil opacity-60" />
        </span>
      ) : null}
    </span>
  );
}
